import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Pricing',
          path: 'pricing',
          component: () => import('@/views/pages/Pricing'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        {
          name: 'Home',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        {
          name: 'Cadastro',
          path: '/cadastro',
          component: () => import('@/views/dashboard/UserProfile'),
        },
        {
          name: 'Ativação',
          path: '/ativacao',
          component: () => import('@/views/dashboard/UserActive'),
        },
        {
          name: 'Agenda',
          path: '/agenda',
          component: () => import('@/views/dashboard/Widgets'),
        },
        {
          name: 'Configuracoes',
          path: '/configuracoes',
          component: () => import('@/views/dashboard/Settings'),
        },
        {
          name: 'Notificacoes',
          path: '/notificacoes',
          component: () => import('@/views/dashboard/Notifications'),
        },       
        {
          name: 'Serviços agendado',
          path: '/relatorios/relatorioservicoagendado',
          component: () => import('@/views/dashboard/relatorios/RelatorioServicoAgendado'),
        },        
        {
          name: 'Serviços atendido',
          path: '/relatorios/relatorioservicoatendido',
          component: () => import('@/views/dashboard/relatorios/RelatorioServicoAtendido'),
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
